<div class="card-header-wrapper d-flex flex-wrap theme_bg custom_header justify-content-between">
    <div class="name card-header-title custom_title d-flex">
        <div [innerHTML]="title"></div>
        <i class="fa fa-edit" *ngIf="isEditable" (click)="editClicked.emit()"></i>
    </div>
    <div class="action">
        <fap-round-button *ngIf="isAddEnabled" [backgroundColor]="'tertiary'" (clicked)="clicked.emit()"></fap-round-button>
        <span class="ricon" *ngIf="isRefresh" (click)="refreshClicked.emit()"></span>
    </div>
</div>